var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',[_c('section',[_c('header',[_c('h2',[_vm._v("Groups for @"+_vm._s(_vm.$store.state.username))])]),_c('CreateGroup')],1),_c('section',[_vm._m(0),_vm._l((_vm.$store.state.groups),function(group){return _c('Group',{key:group.id,attrs:{"group":group}})})],2)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('header',[_c('h2',[_vm._v("Groups:")])])
}]

export { render, staticRenderFns }